import React, { useState, useEffect } from 'react';
import api, { updateHotpleCache } from '../../api.js';
import AuthModal from './Modal/Auth/AuthModal.js';
import styles from './MainFrame.module.css';
import NaverMap from './Map/NaverMap.js';
import BrowserSideTab from './SideTab/BrowserSideTab/BrowserSideTab.js';
import BottomSheet from './SideTab/MobileBottomSheet/MobileBottomSheet.tsx';
import {
  BrowserView,
  isIOS,
  isMobile,
  MobileView,
} from "react-device-detect";
import NavigationBar from './SideTab/MobileBottomSheet/NavigationBar.js';
import UserModal from './Modal/User/UserModal.js';
import HotpleModal from './Modal/Hotple/HotpleModal.js';
import InfoModal from './Modal/Info/InfoModal.js';
import { set_MIN_Y } from './SideTab/MobileBottomSheet/MobileBottomSheetOption.js';
import OnbaordPage from './Onboard/OnbaordPage.js';
import TutorialModal from './Modal/Tutorial/TutorialModal.js';
import HotModal from './Modal/HotModal/HotModal.js';
import HotpleDetailPage from '../HotpleDetail/HotpleDetailPage.js';
import TutorialMainPage from '../Tutorial/TutorialMainPage.js';
import MediaPage from './SideTab/Common/Contents/Media/MediaPage.js';

const MainFrame = () => {
  const [tutorialModalPage, setTutorialModalPage] = useState(0);
  const [authModalPage, setAuthModalPage] = useState(0);
  const [userModalPage, setUserModalPage] = useState(0);
  const [infoModalPage, setInfoModalPage] = useState(0);
  const [hotpleModalPage, setHotpleModalPage] = useState(0);
  const [anlysisPageHotple, setAnlysisPageHotple] = useState(null);
  const [isHotModalShown, setIsHotModalShown] = useState(false);
  const [needOnbaord, setNeedOnbaord] = useState(false);
  const [mapLocation, setMapLocation] = useState({name: null, address: '', latitude: null, longitude: null});
  const [modalProps, setModalProps] = useState({});
  const [selectedOption, setSelectedOption] = useState({region:'전국', category: 'recommend', filter: 'all', sub_category: 'all', shop_category: 'top20', shop_brand: 'popular'})
  const [activeMenu, setActiveMenu] = useState('search');
  const [account, setAccount] = useState({hotpleId:null, instagramUsername:null, level:0, xp:{total_xp:0, level_xp:0, level_max:500}, tutorial_phase:1, hp:0});
  const [hotpleStore, setHotpleStore] = useState(() => new Map());
  const [myHotpleIds, setMyHotpleIds] = useState([]);              // was: myHotples
  const [rangeHotpleIds, setRangeHotpleIds] = useState([]);        // was: rangeHotples
  const [recommendHotpleIds, setRecommendHotpleIds] = useState([]);// was: recommendHotples
  const [adminHotpleIds, setAdminHotpleIds] = useState([]);        // was: adminHotples
  const [mapHotpleIds, setMapHotpleIds] = useState([]);
  const [notices, setNotices] = useState([]);
  const [shopItems, setShopItems] = useState([]);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [selectedHotple, setSelectedHotple] = useState(null);
  const [periodHotpleGroup, setPeriodHotpleGroup] = useState([]);
  const [marginTop, setMarginTop] = useState(0);
  const [platform, setPlatform] = useState('web');
  const [fcmToken, setFcmToken] = useState(null);
  const [appVersion, setAppVersion] = useState(null);
  const [perm, setPerm] = useState({locationPerm: null, notificationPerm: null});
  const [devicePosition, setDevicePosition] = useState({lat:37.5695704, long:126.978399});
  const [hotThreshold, setHotThreshold] = useState(999999);
  const [ignoreAppModal, setIgnoreAppModal] = useState(false);

  // 여러 hotple들을 한 번에 Map에 업서트
  const upsertHotples = React.useCallback((hotples) => {
    setHotpleStore(prev => {
      const next = new Map(prev);
      hotples.forEach(h => {
        if (h?.hotple_id != null) next.set(h.hotple_id, h);
      });
      return next;
    });
  }, []);

  // 단일 hotple 업서트
  const upsertHotple = React.useCallback((hotple) => {
    if (!hotple?.hotple_id) return;
    setHotpleStore(prev => {
      const next = new Map(prev);
      next.set(hotple.hotple_id, hotple);
      return next;
    });
  }, []);

  const isPicked = React.useCallback((id) => {
    return myHotpleIds.includes(id);
  }, [myHotpleIds]);

  // hotple -> UI용으로 is_pick 덮어쓰기(스토어는 안 건드림)
  const augmentWithPick = React.useCallback((h) => {
    return h ? { ...h, is_pick: isPicked(h.hotple_id) } : h;
  }, [isPicked]);

  // id 배열 -> 객체 배열
  const selectHotplesByIds = React.useCallback((ids) => {
    return ids.map(id => hotpleStore.get(id)).filter(Boolean);
  }, [hotpleStore]);

  // 기존 컴포넌트와 호환: {hotples:[…]} 형태로 반환하는 memoized selector들
  const myHotples = React.useMemo(() => ({ hotples: selectHotplesByIds(myHotpleIds).map(augmentWithPick) }), [myHotpleIds, selectHotplesByIds, augmentWithPick]);
  const rangeHotples = React.useMemo(() => ({ hotples: selectHotplesByIds(rangeHotpleIds).map(augmentWithPick) }), [rangeHotpleIds, selectHotplesByIds, augmentWithPick]);
  const recommendHotples = React.useMemo(() => ({ hotples: selectHotplesByIds(recommendHotpleIds).map(augmentWithPick) }), [recommendHotpleIds, selectHotplesByIds, augmentWithPick]);
  const adminHotples = React.useMemo(() => ({ hotples: selectHotplesByIds(adminHotpleIds).map(augmentWithPick) }), [adminHotpleIds, selectHotplesByIds, augmentWithPick]);
  const mapHotples = React.useMemo(() => ({ hotples: selectHotplesByIds(mapHotpleIds).map(augmentWithPick) }), [mapHotpleIds, selectHotplesByIds, augmentWithPick]);

  const detailHotple = React.useMemo(() => {
    if (!anlysisPageHotple?.hotple_id) return null;
    const fresh = hotpleStore.get(anlysisPageHotple.hotple_id) || anlysisPageHotple;
    return augmentWithPick(fresh);
  }, [anlysisPageHotple?.hotple_id, hotpleStore, augmentWithPick]);

  // selectedHotple도 id만 저장하도록 바꿀 수 있지만, 하위 컴포넌트 호환을 위해 객체 유지
  // 단, 내부적으로는 store에서 최신 객체를 바라보도록 sync
  useEffect(() => {
    if (selectedHotple?.hotple_id) {
      const fresh = hotpleStore.get(selectedHotple.hotple_id);
      if (fresh && fresh !== selectedHotple) setSelectedHotple(fresh);
    }
  }, [hotpleStore, selectedHotple]);


  const handleAutoLogin = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    const params = new URLSearchParams(window.location.search);
    const hotpleId = params.get('hotple_id');
    const menu = params.get('menu');

    if (refreshToken) {
      try {
        const response = await api.post('/auth/refresh_token', {
          refreshToken,
        });

        const { accessToken, refreshToken: newRefreshToken } = response.data;

        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', newRefreshToken);

        getMyInfo();
      } catch (error) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        
        if((menu=='my' || menu=='admin') && hotpleId)
          setAuthModalPage(1);
      }
    }
    else{
      if((menu=='my' || menu=='admin') && hotpleId)
        setAuthModalPage(1);
    }
  };

  const cleanExpiredPopupNotices = () => {
    const now = new Date();

    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (key.startsWith('popup_')) {
            const storedExpiry = localStorage.getItem(key);

            if (storedExpiry) {
                const expiryDate = new Date(storedExpiry);
                if (expiryDate <= now) {
                    localStorage.removeItem(key);
                }
            }
        }
    }
  };

  const sendFcmToken = async (fcm_token) => {
    try {
      const response = await api.post(`/auth/fcmToken`, {
        fcm_token,
        platform,
        isPermissionAllow: perm.notificationPerm
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getNotices = async () => {
    cleanExpiredPopupNotices();

    const response = await api.get(`/notice`);
    const noticeList = response.data;

    const popupNoticeList = noticeList.filter(notice => {
        if (notice.popup_image_url) {
            const storedExpiry = localStorage.getItem(`popup_${notice.id}`);
            if (storedExpiry) {
                const expiryDate = new Date(storedExpiry);
                if (expiryDate > new Date()) {
                    return false;
                }
            }
            return true;
        }
        return false;
    });

    setNotices(noticeList);

    if (popupNoticeList.length > 0) {
      const params = new URLSearchParams(window.location.search);
      const hotpleId = params.get('hotple_id');
      const menu = params.get('menu');

      if (!(menu || hotpleId)) {
        setModalProps({ popupNoticeList: popupNoticeList });
        setInfoModalPage(2);
      }
    }
  };

  const getShopItems = async () => {
    const response = await api.get(`/shop/items`);
    const itemList = response.data;

    setShopItems(itemList);
  };

  const getMyInfo = async () => {
    try {
      const response = await api.get(`/user/my/`);

      let accountInfo = {
        hotpleId:response.data.user_id,
        instagramUsername:response.data.instagram_username,
        level:response.data.level,
        xp:response.data.xp,
        tutorial_phase:response.data.tutorial_phase,
        hp:response.data.hp,
        auth_provider:response.data.auth_provider
      };
      if(response.data.is_admin)
        accountInfo.isAdmin = true;

      setAccount(accountInfo);
      if(response?.data?.new_hotples?.length >= 1){
        setModalProps({new_hotples: response.data.new_hotples});
        setUserModalPage(2);
      }

      getMyHotple(accountInfo.isAdmin);

      return response.data.tutorial_phase;
      /*if(response.data.instagram_username==null)
        setAuthModalPage(3);*/
    } catch (error) {
      console.error('Error fetching data:', error);
      return 0;
    }
  };

  const getMyHotple = async (is_admin=false) => {
    try {
      const response = await api.get(`/hotple/my/`);
      const list = response.data?.hotples ?? [];

      // 1) store 업서트
      upsertHotples(list);

      // 2) id만 저장
      setMyHotpleIds(list.map(h => h.hotple_id));

      // 쿼리 파라미터 처리 (기존 동작 동일)
      const params = new URLSearchParams(window.location.search);
      const hotpleId = params.get('hotple_id');
      const menu = params.get('menu');

      if (menu == 'my' && hotpleId) {
        setActiveMenu(menu);
        setTimeout(() => {
          const found = hotpleStore.get(Number(hotpleId)) || list.find(h => h.hotple_id == hotpleId);
          if (found) setSelectedHotple(found);
          const newUrl = window.location.pathname;
          window.history.replaceState({}, '', newUrl);
        }, 200);
      } else if (menu == 'admin' && hotpleId) {
        if (is_admin) setActiveMenu(menu);
        else {
          const newUrl = window.location.pathname;
          window.history.replaceState({}, '', newUrl);
        }
      }
    } catch (e) {
      console.error('Error fetching data:', e);
    }
  };


  const getAdminHotples = async () => {
    try {
      const response = await api.get(`/admin/hotple/`);
      const list = response.data?.hotples ?? [];

      upsertHotples(list);
      setAdminHotpleIds(list.map(h => h.hotple_id));

      const params = new URLSearchParams(window.location.search);
      const hotpleId = params.get('hotple_id');
      const menu = params.get('menu');

      if (menu == 'admin' && hotpleId) {
        setTimeout(() => {
          const found = hotpleStore.get(Number(hotpleId)) || list.find(h => h.hotple_id == hotpleId);
          if (found) setSelectedHotple(found);
          const newUrl = window.location.pathname;
          window.history.replaceState({}, '', newUrl);
        }, 200);
      }
    } catch (e) {
      console.error('Error fetching data:', e);
    }
  };


  const updateHotpleInfo = (action, hotple=null) => {
    switch(action){
      case 'updateIsPick':
        if (account.hotpleId == null) {
          setAnlysisPageHotple(null);
          setAuthModalPage(1);
        }
        else {
          const id = hotple?.hotple_id;
          if (!id) break;
          const picked = isPicked(id);

          // 1) id 배열 갱신
          if (picked) {
            setMyHotpleIds(prev => prev.filter(x => x !== id));
          } else {
            setMyHotpleIds(prev => (prev.includes(id) ? prev : [...prev, id]));
          }

          // 2) 전역 카운트(mention_count)만 낙관적 업데이트
          const cur = hotpleStore.get(id);
          if (cur) {
            const nextCount = (cur.mention_count || 0) + (picked ? -1 : +1);
            upsertHotple({ ...cur, mention_count: Math.max(0, nextCount) });
          }

          // 3) 서버 반영 (실패해도 UI는 나중에 동기화)
          api.patch(`/user/pick/`, { is_pick: !picked, hotple_id: id }).catch(err => console.error(err));
        }
        break;
      case 'showDeleteMyHotpleModal':
        setModalProps({hotple});
        setUserModalPage(1);
        break;

      case 'showDeleteHotpleModal':
        setModalProps({hotple, is_remove:true});
        setUserModalPage(1);
        break;

      case 'showVerifyHotpleModal':
        setModalProps({hotple, is_verify:true});
        setHotpleModalPage(1);
        break;

      case 'showEditHotpleModal':
        setModalProps({hotple});
        setHotpleModalPage(11);
        break;

      case 'showEditRequestModal':
        setModalProps({hotple});
        setHotpleModalPage(21);
        break;

      case 'showImageEditHotpleModal':
        setModalProps({hotple});
        setHotpleModalPage(31);
        break;

      case 'AddNewHotpleAndEdit':
        addAdminHotpleIfNotExist(hotple);
        setModalProps({hotple, is_verify:true});
        setHotpleModalPage(1);
        break;

      case 'deleteMyHotple':
        deleteMyHotple(hotple);
        updateHotpleInfoFromListExceptMyHotples(hotple);
        break;

      case 'deleteHotple':
        deleteHotple(hotple);
        break;

      case 'refreshAdminHotples':
        getAdminHotples();
        break;

      case 'updateHotpleImagesFromList':
        updateHotpleInfoFromListExceptMyHotples(hotple);
        updateMyHotple(hotple);
        break;

      case 'changeHotpleAfterInference':
        addAdminHotpleIfNotExist(hotple);
        break;

      case 'updateHotpleInfoFromList':
        updateHotpleInfoFromListExceptMyHotples(hotple);
        updateMyHotple(hotple);
        break;

      default:
        break;
    }
  };

  const updateHotpleInfoFromListExceptMyHotples = (hotple) =>{
    upsertHotple(hotple);
    updateHotpleCache(hotple);
  };

  const deleteMyHotple = async (deleteHotple) => {
    if (myHotpleIds.includes(deleteHotple.hotple_id)) {
      setMyHotpleIds(prev => prev.filter(id => id !== deleteHotple.hotple_id));
      setUserModalPage(0);
      if (activeMenu=='my') setSelectedHotple(null);

      const cur = hotpleStore.get(deleteHotple.hotple_id);
      if (cur) upsertHotple({ ...cur, mention_count: Math.max(0, (cur.mention_count || 0) - 1) });

      try {
        await api.patch(`/user/pick/`, {
          is_pick: false,
          hotple_id: deleteHotple.hotple_id
        });
      } catch (e) {
        console.error('Error fetching data:', e);
      }
    }
  };

  const deleteHotple = async (deleteHotple) => {
    setSelectedHotple(null);

    // 각 목록의 id 배열에서만 제거
    setMyHotpleIds(prev => prev.filter(id => id !== deleteHotple.hotple_id));
    setAdminHotpleIds(prev => prev.filter(id => id !== deleteHotple.hotple_id));
    setRangeHotpleIds(prev => prev.filter(id => id !== deleteHotple.hotple_id));
    setRecommendHotpleIds(prev => prev.filter(id => id !== deleteHotple.hotple_id));

    setUserModalPage(0);

    try {
      await api.delete(`/admin/hotple/${deleteHotple.hotple_id}`);
    } catch (e) {
      console.error('Error fetching data:', e);
    }
  };

  const updateMyHotple = (newHotple) => { upsertHotple(newHotple); };
  const updateRangeHotple = (newHotple) => { upsertHotple(newHotple); };
  const updateRecommendHotple = (newHotple) => { upsertHotple(newHotple); };
  const updateAdminHotple = (newHotple) => { upsertHotple(newHotple); };
  const updateMapHotple = (newHotple) => { upsertHotple(newHotple); };

  const setRangeHotples = (payload) => {
    const ids = Array.isArray(payload) ? payload : (payload?.hotples ?? []).map(h => h.hotple_id);
    // store 업서트도 같이 (객체가 들어왔을 때만)
    if (!Array.isArray(payload) && payload?.hotples) upsertHotples(payload.hotples);
    setRangeHotpleIds(ids);
  };

  const setRecommendHotples = (payload) => {
    const ids = Array.isArray(payload) ? payload : (payload?.hotples ?? []).map(h => h.hotple_id);
    if (!Array.isArray(payload) && payload?.hotples) upsertHotples(payload.hotples);
    setRecommendHotpleIds(ids);
  };

  const addMyHotpleIfNotExist = async (newHotple) => {
    upsertHotple(newHotple);
    setMyHotpleIds(prev => (prev.includes(newHotple.hotple_id) ? prev : [...prev, newHotple.hotple_id]));
    try {
      await api.patch(`/user/pick/`, { is_pick: true, hotple_id: newHotple.hotple_id });
    } catch (e) { console.error('Error fetching data:', e); }
  };

  const addAdminHotpleIfNotExist = async (newHotple) => {
    upsertHotple(newHotple);
    setAdminHotpleIds(prev => {
      const exist = prev.includes(newHotple.hotple_id);
      // old_hotple_id 대체(있으면 제거)
      const filtered = prev.filter(id => id !== newHotple.old_hotple_id);
      return exist ? filtered : [newHotple.hotple_id, ...filtered];
    });
  };

  const getFilteredMapHotpleIds = (ids) => {
    // store 기반으로 필터링
    const hotples = ids.map(id => hotpleStore.get(id)).filter(Boolean);

    const toKor = (cat) => ({
      cafe:'카페디저트', alcohol:'주점', restaurant:'음식점', popupStore:'팝업스토어',
      cultural:'문화예술', activity:'오락액티비티', rest:'휴식힐링', accommodation:'숙소',
      recommend:'추천'
    }[cat] || '추천');

    const category_kor = selectedOption.category.startsWith('@')
      ? '추천'
      : toKor(selectedOption.category);

    let filtered = hotples;

    if (selectedOption.region!=='전국' && selectedOption.region!=='위치')
      filtered = filtered.filter(h => h.region == selectedOption.region);

    if (selectedOption.category!=='recommend' && !selectedOption.category.startsWith('@'))
      filtered = filtered.filter(h => h.main_category == category_kor);

    if (selectedOption.sub_category!=='all')
      filtered = filtered.filter(h => h.sub_category1 == selectedOption.sub_category || h.sub_category2 == selectedOption.sub_category);

    if (activeMenu=='my' || activeMenu=='admin') {
      switch(selectedOption.filter){
        case null:
        case 'all':
          break;
        case 'need_verify':
          filtered = filtered.filter(h => h.need_verify === true);
          break;
        case 'my_pick':
          if (activeMenu=='admin') setSelectedOption(prev=>({...prev, filter:'all'}));
          else filtered = filtered.filter(h => h.taggedBy == null);
          break;
        case 'has_period':
          filtered = filtered.filter(h => h.has_period === true);
          break;
        case 'edit_request':
          if (activeMenu=='my') setSelectedOption(prev=>({...prev, filter:'all'}));
          else filtered = filtered.filter(h => h.verify_results && h.verify_results.length>0);
          break;
        case 'err_image':
          if (activeMenu=='my') setSelectedOption(prev=>({...prev, filter:'all'}));
          else filtered = filtered.filter(h => !h.preview_url || !h.contents_url || h.contents_url.length==0);
          break;
        case 'err_info':
          if (activeMenu=='my') setSelectedOption(prev=>({...prev, filter:'all'}));
          else filtered = filtered.filter(h => !h.name || !h.caption || !h.main_category || !h.sub_category1 || !h.sub_category2 || !h.tags || !h.place_name || !h.address || !h.region || !h.latitude || !h.longitude || !h.media_url);
          break;
        case 'err_place':
          if (activeMenu=='my') setSelectedOption(prev=>({...prev, filter:'all'}));
          else filtered = filtered.filter(h => h.address && !((h.region == h.address.substring(0,2)) || h.region == h.address.charAt(0) + h.address.charAt(2)));
          break;
        case 'err_kakao':
          if (activeMenu=='my') setSelectedOption(prev=>({...prev, filter:'all'}));
          else filtered = filtered.filter(h => !h.kakao_map_place_id);
          break;
        default: // username
          filtered = filtered.filter(h => (h.taggedBy == selectedOption.filter || (h.comment && h.comment.includes(selectedOption.filter))));
      }
    }

    return filtered.map(h => h.hotple_id);
  };

  const setFilteredMapHotples = (hotplesLike) => {
    // hotplesLike는 기존처럼 {hotples:[…]} 도 들어올 수 있고,
    // 이제부터는 id 배열만 줄 수도 있어. 둘 다 호환.
    const ids = Array.isArray(hotplesLike)
      ? hotplesLike
      : (hotplesLike?.hotples ?? []).map(h => h.hotple_id);

    setMapHotpleIds(getFilteredMapHotpleIds(ids));
  };


  async function getHotpleGroup(){
    const response = await api.get(`/hotple_groups`);

    if(response)
      setPeriodHotpleGroup(response.data);
  }

  const showTermsAndConditions = (idx) => {
		switch(idx){
			case 1:
				setModalProps({images:['https://hotple.s3.ap-northeast-2.amazonaws.com/terms/a.jpg']});
				break;
			case 2:
				setModalProps({images:['https://hotple.s3.ap-northeast-2.amazonaws.com/terms/b.jpg']});
				break;
			case 3:
				setModalProps({images:['https://hotple.s3.ap-northeast-2.amazonaws.com/terms/c.jpg']});
				break;	
		}

		setUserModalPage(5);
	};

  const checkAndRedirectToApp = () => {
    const currentUrl = window.location.href;
    const appUrl = `hotple://${currentUrl.replace(/^https?:\/\//, "")}`;
  
    // 인앱 환경 감지: 인앱 브라우저(WebView)에서는 실행하지 않음
    const isInApp = navigator.userAgent.includes("HotpleApp");
  
    if (isInApp) {
      return;
    }
  
    window.location.href = appUrl;
  };

  const checkAndGoToAppStore = () => {
    const currentUrl = window.location.href;
    const isInApp = navigator.userAgent.includes("HotpleApp");

    // 인앱(WebView) 환경에서는 동작 X
    if (isInApp) return;

    const storeUrl = isIOS
      ? "https://apps.apple.com/kr/app/hotple-%EC%9D%B8%EC%8A%A4%ED%83%80-%ED%95%AB%ED%94%8C-%EC%A7%80%EB%8F%84-%EB%A7%9B%EC%A7%91-%EC%B9%B4%ED%8E%98-%EC%97%AC%ED%96%89-%EB%8D%B0%EC%9D%B4%ED%8A%B8/id6739356719" // iOS 앱스토어 URL
      : "https://play.google.com/store/apps/details?id=com.hotple.hotple"; // Android Play 스토어 URL

    const appSchemeUrl = isIOS
      ? `hotple://${currentUrl.replace(/^https?:\/\//, "")}` // iOS용 딥링크
      : `intent://${currentUrl.replace(/^https?:\/\//, "")}#Intent;package=com.hotple.hotple;scheme=hotple;end`; // Android intent 스킴

    // iOS에서 백그라운드 전환 유도를 위해 iframe 활용
    if (isIOS) {
      window.location.href = storeUrl;
    } else {
      // Android는 intent 스킴 직접 사용 가능
      window.location.href = appSchemeUrl;
    }
  };

  async function updateHotThreshold() {
    const response = await api.get(`/hotple/hot_threshold`);
    if(response.data)
      setHotThreshold(response.data.hotThreshold);
  }
  

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const idx = params.get('idx');
    const menu = params.get('menu');
    const path = window.location.pathname;

    if (path === '/ig') {
      const newUrl = window.location.origin;
      window.history.replaceState({}, '', newUrl);
    }
    else if (/^\/ig\/[^/]+$/.test(path)) {
      const region = path.split('/').pop();
      const newUrl = `${window.location.origin}?menu=search&region=${region}`;
      window.location.replace(newUrl);
    }
    else if (path === '/fb') {
      const newUrl = window.location.origin;
      window.history.replaceState({}, '', newUrl);
    }
    else if (/^\/fb\/[^/]+$/.test(path)) {
      const region = path.split('/').pop();
      const newUrl = `${window.location.origin}?menu=search&region=${region}`;
      window.location.replace(newUrl);
    }

    setNeedOnbaord(localStorage.getItem('finishOnbaord') ? false : true);

    window.setPerm = function (locationPerm, notificationPerm) {
      setPerm({locationPerm: locationPerm, notificationPerm: notificationPerm});
    };

    window.setDevicePosition = function (lat, long) {
      setDevicePosition({ lat, long });
    };

    window.setAppSetting = function (safeAreaHeight, platform, fcmToken, locationPerm, notificationPerm, appVersion) {
      setMarginTop(safeAreaHeight>50?safeAreaHeight-8:safeAreaHeight);
      set_MIN_Y(safeAreaHeight>50?safeAreaHeight-8:safeAreaHeight);
      setPlatform(platform);
      setFcmToken(fcmToken);
      setPerm({locationPerm: locationPerm, notificationPerm: notificationPerm});
      setAppVersion(appVersion);
      setTimeout(() => {
        if(platform=='ios' && !appVersion){
          alert('간헐적으로 잘못된 인스타그램 게시글로 이동되는 버그가 수정되었어요!\n\n안정적인 서비스 제공을 위해 앱 업데이트를 부탁드려요🙂');
          const storeUrl = "https://apps.apple.com/kr/app/hotple-%EC%9D%B8%EC%8A%A4%ED%83%80-%ED%95%AB%ED%94%8C-%EC%A7%80%EB%8F%84-%EB%A7%9B%EC%A7%91-%EC%B9%B4%ED%8E%98-%EC%97%AC%ED%96%89-%EB%8D%B0%EC%9D%B4%ED%8A%B8/id6739356719" // iOS 앱스토어 URL
          window.location.href = storeUrl;
        }
      }, 500);
    };

    window.requestUpdate = function () {
      getMyInfo();
    };

    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('CustomChannel', 'REACT_RENDERED');
    }

    if(isMobile){
      checkAndRedirectToApp();
    }

    handleAutoLogin();
    getNotices();
    getShopItems();
    getHotpleGroup();
    updateHotThreshold();

    if(menu == 'terms' && idx){
      showTermsAndConditions(Number(idx));

      const newUrl = path;
      window.history.replaceState({}, '', newUrl);
    }
    else if (path.endsWith('/usage')) {
      setInfoModalPage(1);

      const newUrl = window.location.origin;
      window.history.replaceState({}, '', newUrl);
    }
    else if (path.endsWith('/delete_account')) {
      setAuthModalPage(5);

      const newUrl = window.location.origin;
      window.history.replaceState({}, '', newUrl);
    }
    else if (path.endsWith('/tutorial')) {
      setTutorialModalPage(1);

      const newUrl = window.location.origin;
      window.history.replaceState({}, '', newUrl);
    }
    else if (path.endsWith('/instagram_connect')) {
      setAuthModalPage(3);

      const newUrl = window.location.origin;
      window.history.replaceState({}, '', newUrl);
    }
    else if (path.endsWith('/xp')) {
      setUserModalPage(4);

      const newUrl = window.location.origin;
      window.history.replaceState({}, '', newUrl);
    }
    else if (path.endsWith('/hp')) {
      setModalProps({type:'HP'});
      setUserModalPage(6);
      setTimeout(() => {
        setActiveMenu('shop');
      }, 500);
      
      const newUrl = window.location.origin;
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  useEffect(() => {
    setSelectedHotple(null);

    if (activeMenu=='my') {
      window.requestUpdate();
      if (account.hotpleId!=null) setFilteredMapHotples(myHotples); // ← 그대로 사용 가능 (호환 레이어)
      else { setAuthModalPage(1); setMapHotpleIds([]); }
    } else if (activeMenu=='home') {
      setFilteredMapHotples(recommendHotples);
    } else if (activeMenu=='admin') {
      if (adminHotpleIds.length>0) setFilteredMapHotples(adminHotples);
      else { setMapHotpleIds([]); getAdminHotples(); }
    } else if (activeMenu=='shop') {
      window.requestUpdate();
      setMapHotpleIds([]);
    }

    if(activeMenu!='search'){
      if(selectedOption.category.startsWith('@')){
        setSelectedOption((prev)=>
          ({...prev,
            region: '전국',
            category:'recommend'
          }))
      }
      else{
        setSelectedOption((prev)=>
          ({...prev,
            region: '전국'
          }));
      }
    }
  }, [activeMenu]);

  useEffect(() => {
    if (activeMenu=='search') setFilteredMapHotples(rangeHotples);
  }, [rangeHotpleIds, activeMenu]); // 의존성: id 배열

  useEffect(() => {
    if (activeMenu=='home') setFilteredMapHotples(recommendHotples);
  }, [recommendHotpleIds, activeMenu]);

  useEffect(() => {
    if (activeMenu=='my' && account.hotpleId!=null) setFilteredMapHotples(myHotples);
  }, [myHotpleIds, account.hotpleId, activeMenu]);

  useEffect(() => {
    if (activeMenu=='admin' && account.hotpleId!=null) setFilteredMapHotples(adminHotples);
  }, [adminHotpleIds, account.hotpleId, activeMenu]);

  useEffect(()=>{
    const isPermChecked = localStorage.getItem('isPermChecked');

    if(!isPermChecked && window.flutter_inappwebview){
      setModalProps({isFirst:true});
      setUserModalPage(3);
    }
  }, [perm])

  useEffect(() => {
    if(account.hotpleId==null){
      setMyHotpleIds([]);
      setMapHotpleIds([]);
      if(activeMenu=='my' || activeMenu=='admin')
        setActiveMenu('search');
    }
  },[account.hotpleId])

  useEffect(() => {
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('CustomChannel', 'SET_INSTAGRAM_HANDLE', `${account.instagramUsername}`);
    }
  },[account.instagramUsername])

  useEffect(() => {
    if(account.hotpleId != null && fcmToken != null){
      sendFcmToken(fcmToken);
    }
  },[fcmToken, account.hotpleId])

  useEffect(() => {
    if (activeMenu=='my' && account.hotpleId!=null) setFilteredMapHotples(myHotples);
    else if (activeMenu=='admin' && account.hotpleId!=null) setFilteredMapHotples(adminHotples);
    else if (activeMenu=='search') setFilteredMapHotples(rangeHotples);
    else if (activeMenu=='home') setFilteredMapHotples(recommendHotples);
  }, [selectedOption]);

  useEffect(() => {
		if(isSearchMode && activeMenu=='home')
      setActiveMenu('search');
	}, [isSearchMode])

  useEffect(() => {
    if (anlysisPageHotple?.hotple_id) {
      const fresh = hotpleStore.get(anlysisPageHotple.hotple_id);
      if (fresh && fresh !== anlysisPageHotple) setAnlysisPageHotple(fresh);
    }
  }, [hotpleStore, anlysisPageHotple]);

  return (
    <div className={styles.mainFrameContainer}>
      <BrowserView className={styles.innerContainer}>
        <BrowserSideTab setUserModalPage={setUserModalPage} setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} setTutorialModalPage={setTutorialModalPage} activeMenu={activeMenu} setActiveMenu={setActiveMenu} notices={notices} account={account} recommendHotples={recommendHotples} myHotples={myHotples} rangeHotples={rangeHotples} mapHotples={mapHotples} adminHotples={adminHotples} updateHotpleInfo={updateHotpleInfo} mapLocation={mapLocation} setIsSearchMode={setIsSearchMode} selectedHotple={selectedHotple} setSelectedHotple={setSelectedHotple} selectedOption={selectedOption} setSelectedOption={setSelectedOption} isAdmin={account.isAdmin} fcmToken={fcmToken} setModalProps={setModalProps} hotThreshold={hotThreshold} shopItems={shopItems} setIsHotModalShown={setIsHotModalShown} devicePosition={devicePosition} setAnlysisPageHotple={setAnlysisPageHotple}/>
        <NaverMap account={account} activeMenu={activeMenu} setActiveMenu={setActiveMenu} selectedOption={selectedOption} setSelectedOption={setSelectedOption} myHotples={myHotples} adminHotples={adminHotples} mapHotples={mapHotples} setRangeHotples={setRangeHotples} setRecommendHotples={setRecommendHotples} mapLocation={mapLocation} setMapLocation={setMapLocation} isSearchMode={isSearchMode} setIsSearchMode={setIsSearchMode} selectedHotple={selectedHotple} setSelectedHotple={setSelectedHotple} setInfoModalPage={setInfoModalPage} periodHotpleGroup={periodHotpleGroup} marginTop={marginTop} platform={platform} devicePosition={devicePosition} setDevicePosition={setDevicePosition} perm={perm} setUserModalPage={setUserModalPage} hotThreshold={hotThreshold} shopItems={shopItems} setIsHotModalShown={setIsHotModalShown} setAuthModalPage={setAuthModalPage} setAnlysisPageHotple={setAnlysisPageHotple} setModalProps={setModalProps}/>
      </BrowserView>

      <MobileView className={styles.innerContainer}>
        <NaverMap account={account} activeMenu={activeMenu} setActiveMenu={setActiveMenu} selectedOption={selectedOption} setSelectedOption={setSelectedOption} myHotples={myHotples} adminHotples={adminHotples} mapHotples={mapHotples} setRangeHotples={setRangeHotples} setRecommendHotples={setRecommendHotples} mapLocation={mapLocation} setMapLocation={setMapLocation} isSearchMode={isSearchMode} setIsSearchMode={setIsSearchMode} selectedHotple={selectedHotple} setSelectedHotple={setSelectedHotple} setInfoModalPage={setInfoModalPage} periodHotpleGroup={periodHotpleGroup} marginTop={marginTop} platform={platform} devicePosition={devicePosition} setDevicePosition={setDevicePosition} perm={perm} setUserModalPage={setUserModalPage} hotThreshold={hotThreshold} shopItems={shopItems} setIsHotModalShown={setIsHotModalShown} setAuthModalPage={setAuthModalPage} setAnlysisPageHotple={setAnlysisPageHotple} setModalProps={setModalProps}/>
        <BottomSheet activeMenu={activeMenu} setActiveMenu={setActiveMenu} setUserModalPage={setUserModalPage} setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} setTutorialModalPage={setTutorialModalPage} notices={notices} account={account} recommendHotples={recommendHotples} myHotples={myHotples} rangeHotples={rangeHotples} mapHotples={mapHotples} adminHotples={adminHotples} updateHotpleInfo={updateHotpleInfo} mapLocation={mapLocation} isSearchMode={isSearchMode} setIsSearchMode={setIsSearchMode} selectedHotple={selectedHotple} setSelectedHotple={setSelectedHotple} selectedOption={selectedOption} setSelectedOption={setSelectedOption} fcmToken={fcmToken} setModalProps={setModalProps} hotThreshold={hotThreshold} shopItems={shopItems} setIsHotModalShown={setIsHotModalShown} devicePosition={devicePosition} setAnlysisPageHotple={setAnlysisPageHotple}/>
        <NavigationBar activeMenu={activeMenu} setActiveMenu={setActiveMenu} isAdmin={account.isAdmin} setIsHotModalShown={setIsHotModalShown}/>
        {platform === 'web' && !ignoreAppModal &&
          <div className={styles.bottomsheetBack}>
            <div className={styles.bottomsheetContainer}>
              <div className={styles.text}>🎉 HOTPLE 앱에선 매주 기프티콘이 팡팡 🎉</div>
              <div className={styles.buttonFrame}>
                <div className={styles.button0} onClick={()=>setIgnoreAppModal(true)} >웹으로 계속</div>
                <div className={styles.button} onClick={checkAndGoToAppStore} >HOTPLE 앱에서 보기</div>
              </div>
            </div>
          </div>
        }
      </MobileView>

      {/* MediaPage(세로 릴스형 "탐색" 신기능, 개발 중)가 핫플샵 탭(activeMenu=='shop')에 얹혀서 화면을 통째로 덮고 있었음.
          진짜 샵 화면(ShopContents)은 BrowserSideTab/MobileBottomSheet에 이미 정상 연결되어 있어서, 여긴 그냥 끊어둠 (삭제 아님, import는 위에 그대로 있음) */}

      {/* 룰렛 등 신기능 개발 중인 TutorialMainPage는 아직 미완성이라 잠시 원래 모달로 되돌려둠 (삭제 아님, import는 위에 그대로 있음) */}
      {tutorialModalPage!=0 && <TutorialModal setTutorialModalPage={setTutorialModalPage} setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} account={account} getMyInfo={getMyInfo} marginTop={marginTop}/>}
      
      {infoModalPage!=0 && <InfoModal infoModalPage={infoModalPage} setInfoModalPage={setInfoModalPage} setAuthModalPage={setAuthModalPage} setUserModalPage={setUserModalPage} modalProps={modalProps} setModalProps={setModalProps} setNotices={setNotices} account={account} perm={perm} platform={platform} devicePosition={devicePosition} myHotples={myHotples} updateHotpleInfo={updateHotpleInfo} getMyInfo={getMyInfo} setIsHotModalShown={setIsHotModalShown}/>}
      {authModalPage!=0 && <AuthModal authModalPage={authModalPage} setAuthModalPage={setAuthModalPage} setInfoModalPage={setInfoModalPage} setUserModalPage={setUserModalPage} modalProps={modalProps} setModalProps={setModalProps} getMyInfo={getMyInfo} setAccount={setAccount} account={account} fcmToken={fcmToken} platform={platform} marginTop={marginTop}/>}
      {userModalPage!=0 && <UserModal userModalPage={userModalPage} setUserModalPage={setUserModalPage} modalProps={modalProps} myHotples={myHotples} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop} hotThreshold={hotThreshold} devicePosition={devicePosition}/>}
      {hotpleModalPage!=0 && <HotpleModal hotpleModalPage={hotpleModalPage} setHotpleModalPage={setHotpleModalPage} modalProps={modalProps} updateHotpleInfo={updateHotpleInfo} account={account} marginTop={marginTop}/>}
      {isHotModalShown && <HotModal setIsHotModalShown={setIsHotModalShown} isAdmin={account.isAdmin} setActiveMenu={setActiveMenu} setInfoModalPage={setInfoModalPage} marginTop={marginTop}/>}

      {(() => {
        const id = anlysisPageHotple?.hotple_id;
        const liked = id ? myHotpleIds.includes(id) : false;
        const count = id ? (hotpleStore.get(id)?.mention_count ?? anlysisPageHotple?.mention_count ?? 0) : 0;
        return (
          <HotpleDetailPage isOpen={!!anlysisPageHotple} onClose={() => setAnlysisPageHotple(null)} hotple={anlysisPageHotple} liked={liked} likeCount={count} hotThreshold={hotThreshold}
            marginTop={marginTop} devicePosition={devicePosition} updateHotpleInfo={updateHotpleInfo} activeMenu={activeMenu} setHotpleModalPage={setHotpleModalPage} setModalProps={setModalProps} />
        );
      })()}

      {platform!='web' && needOnbaord && <OnbaordPage setNeedOnbaord={setNeedOnbaord}/>}

    </div>
  );
};

export default MainFrame;